import { AccountCategory, Vendor } from "./index";

export class ScheduleVendorAcctCategoryAssoc {
    id: number;
    acctCategory: AccountCategory;
    acctCategoryId: number;
    name: string;
    doingBusinessAsName: string;
    sentForPaymentUTCDate?: Date;
    number: string;
    vendor: Vendor;
    paymentHold: boolean;
}